import { CollabCanvas } from "./CollabCanvas"

interface WhiteboardProps {
  className?: string
}

// The shared classroom whiteboard. Real-time collaboration (synced strokes, live
// cursors) comes from CollabCanvas + the session's Yjs doc; rendered outside a
// live session (e.g. the marketing demo) it degrades to a local-only board.
export function Whiteboard({ className }: WhiteboardProps) {
  return <CollabCanvas surface="whiteboard" className={className} />
}
